// vendor js
import 'bootstrap';
import 'popper.js';
import 'select2';

import './helpers/assets';

import './widgets/forms/contacts-form';
import './widgets/forms/order-form';
import './widgets/forms/register-form';
import './widgets/forms/questionnaire-form';
import './widgets/forms/profile-form';
import './widgets/forms/filter-form';
import './widgets/forms/support-form';
import './widgets/modals/agreement-modal';
import './widgets/modals/tickets-question-modal';
import './widgets/main';
import './widgets/office/adv-banners-list';
import './widgets/office/product-groups';
import './widgets/office/uni-settings-list';
import './widgets/office/exhibitions-select';
import './widgets/office/ads-list';
import './widgets/office/devices';
import './widgets/public/bookmarks';
import './widgets/public/contacts';
import './widgets/public/exhibitions';
import './widgets/public/recommendation';
import './widgets/public/notifications';
import './widgets/public/pjax';
import './widgets/public/calendar';
import './widgets/public/popup';
import './widgets/public/profile';
import './widgets/public/socket';
import './widgets/public/ads';
import './widgets/public/statistic';
import './widgets/public/registration';
import './widgets/public/faq';
import './widgets/public/translate';
